import { useQuery } from "@tanstack/react-query";
import { QueryKeysConfig } from "@/config/query-keys";
import { checkWpAuth } from "@/server-functions/check-wp-auth";

export const useWpAuth = () => {
  return useQuery({
    queryKey: [QueryKeysConfig.wpAdminAuth],
    queryFn: () => checkWpAuth(),
    staleTime: Infinity,
    gcTime: Infinity,
  })?.data;
};
